import { footerCols, navTabs } from "@/mocks/homeData";
import { Shell } from "./ui";

export default function Footer() {
  return (
    <footer className="bg-primary-100/60 text-foreground-800">
      <Shell>
        {/* 主脚区 */}
        <div className="grid grid-cols-1 gap-10 border-b border-primary-200/60 py-12 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <a href="#top" className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-spy-fill text-xl" />
              </span>
              <span className="font-heading text-[22px] font-black text-foreground-950">黑料王</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              专注还原反转、打脸、辟谣、实锤与事件后续。以可复核证据为准绳，帮你在真假之间看清来龙去脉。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              {["辟谣求真", "实锤有据", "后续追踪"].map((t) => (
                <a key={t} href="#fact" className="rounded-full border border-primary-200 bg-background-50/70 px-3 py-1 text-xs font-medium text-primary-800 transition hover:bg-primary-500 hover:text-background-50">
                  #{t}
                </a>
              ))}
            </div>
          </div>

          {footerCols.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="mb-4 text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="group inline-flex items-center gap-1 text-sm text-foreground-600 transition hover:text-primary-700">
                      <i className="ri-arrow-right-s-line text-xs opacity-0 transition group-hover:opacity-100" />
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <h4 className="mb-4 text-sm font-bold text-foreground-950">快捷直达</h4>
            <ul className="space-y-2.5">
              {navTabs.map((t) => (
                <li key={t.id}>
                  <a href={`#${t.id}`} className="inline-flex items-center gap-1 text-sm text-foreground-600 transition hover:text-primary-700">
                    <i className="ri-arrow-right-s-line" />
                    {t.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#top" className="inline-flex items-center gap-1 text-sm text-foreground-600 transition hover:text-primary-700">
                  <i className="ri-arrow-right-s-line" />
                  返回顶部
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* 底部版权 */}
        <div className="flex flex-col items-center justify-between gap-2 py-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 黑料王网 · 内容仅供信息参考，立场中立，尊重各方回应。</p>
          <p className="flex flex-wrap items-center gap-3">
            <a href="#top" className="hover:text-primary-700">免责声明</a>
            <span className="text-primary-300">|</span>
            <a href="#top" className="hover:text-primary-700">证据准则</a>
            <span className="text-primary-300">|</span>
            <a href="#top" className="hover:text-primary-700">线索举报</a>
            <span className="text-primary-300">|</span>
            <span className="inline-flex items-center gap-1"><i className="ri-shield-check-line text-primary-600" />核验驱动，理性吃瓜</span>
          </p>
        </div>
      </Shell>
    </footer>
  );
}